module.exports = __webpack_public_path__ + "assets/img/riskhub-logo-v3-no-text.67be75ea.svg";